import onGetNotes from './onGetNotes';
import onGetMoreNotes from './onGetMoreNotes';
import onGetNote from './onGetNote';

export default {
  onGetNotes,
  onGetMoreNotes,
  onGetNote,
};
